<template>
<div id="photography-page">
    <PhotographyImages />
    <Album />
</div>
</template>

<script>
import PhotographyImages from '../components/photography/PhotographyImages.vue'
import Album from '../components/photography/Album.vue'

export default {
    name: 'PhotographyPage',
    components: { PhotographyImages, Album },
}
</script>

<style scoped>
#photography-page{
    width: 100%;
    min-width: 1000px;
}
h1{
    font-size: 30px;
    line-height: 1.5;
    text-align: center;
    color: #111111;
    font-family: "Comic Sans MS", "Comic Sans", "cursive";
    font-weight: bolder;
}
</style>